import React from "react";
import { bool, string, any } from "prop-types";

import "./icon.m.css";

const Icon = ({ isShareRequired, children, text, type }) => (
  <div styleName={type} className={type}>
    {children}

    {isShareRequired && (
      <div styleName="icon-title" className="icon-title">
        {text}
      </div>
    )}
  </div>
);

Icon.defaultProps = {
  isShareRequired: true,
  text: "Share",
};

Icon.propTypes = {
  isShareRequired: bool,
  text: string,
  type: string,
  children: any,
};

export default Icon;
